namespace advisorop.services {
    `use strict`;

    export class RmdTrackerApi {

        readonly apiUrl = `/api/rmdtracker`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getRMDTrackingData(adminMode: boolean, firmId: number): ng.IHttpPromise<any> {
            return this.$http.get(`${this.apiUrl}/rmdmonitor/` + adminMode + '/' + firmId);
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("rmdTrackerApi", RmdTrackerApi);
}